import { render, staticRenderFns } from "./innovativeResources.vue?vue&type=template&id=643fef16&scoped=true&"
import script from "./innovativeResources.vue?vue&type=script&lang=js&"
export * from "./innovativeResources.vue?vue&type=script&lang=js&"
import style0 from "./innovativeResources.vue?vue&type=style&index=0&id=643fef16&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643fef16",
  null
  
)

export default component.exports